var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.71 85.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-6,.cls-9{fill:#373435;}.cls-2{fill:none;}.cls-3{fill:#528aea;}.cls-4,.cls-6{font-size:16px;font-family:Helvetica-Light, Helvetica;font-weight:300;}.cls-5{letter-spacing:0.08em;}.cls-6{letter-spacing:-0.01em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:0.08em;}.cls-9{font-size:10px;font-family:HelveticaNeue, Helvetica Neue;}.cls-10{letter-spacing:0.13em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trans-Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.36,25.65h4.75v3.41H8.41V48.39c0,1-.35,2.19,1.89,2.19H13V54H8.57c-2.4,0-4.18-.36-4.18-4.64V29.06H.46V25.65H4.39V18h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.64,30.29h.11c1.68-3.73,4.08-5.31,8.31-4.95v4c-5.2-.92-8.26,2.34-8.26,7.49V54h-4V25.65h3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.34,54a5.93,5.93,0,0,0-.91.2c-3.42.16-4.7-.15-5.1-4h-.11A7.19,7.19,0,0,1,41,54.76c-5.66,0-7.29-3.16-7.29-8.31,0-1.07.15-5.15,4.08-6.88,2.29-1,8-3.16,8.52-3.57.86-.66.76-1.79.76-3.26,0-3.22-1.22-4.44-4.49-4.44-3.67,0-4.18,1.68-4.13,5H34.78c-.2-5.87,2.7-8.42,8.42-8.42,8.41,0,7.7,7,7.7,7.7V48.85c0,.71-.11,1.73.71,2.14a5,5,0,0,0,1.73,0ZM46.71,38.7c-2,1.17-4.23,2-6.37,3.06-1.89.87-2.5,3-2.5,4.9,0,2.85.71,4.69,4,4.69,1.53,0,4.89-1.17,4.89-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.83,28.76c2-2.45,4.13-3.88,7.19-3.88,4.23,0,7,2.25,7,7.24V54H73V33.24c0-3-1-4.94-4.23-4.94a5.77,5.77,0,0,0-4,1.58C63.14,31.36,62.93,33,62.93,35V54h-4V25.65h3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.59,33.24c.15-3.36-1.07-4.94-4.49-4.94-2.85,0-4.48,1.32-4.48,4.28,0,3.67,3,4.13,5.76,5.31,4.08,1.83,8.16,2.85,8.16,8.15S97.76,54.82,92,54.76c-2.5.06-5.56-.81-7-2.95-1.68-2.25-1.58-4.13-1.58-6.07h3.83c-.16,3.47,1,5.61,4.79,5.61,3.26,0,5.41-1.33,5.41-4.8,0-4-4.08-4.38-7-5.6-4.39-1.64-6.94-3.12-6.94-8.06s3.42-8,8.32-8c5.61,0,8.87,2.55,8.77,8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.94,63.59h-4V25.65h3.88v3.16h.1a6.77,6.77,0,0,1,5.87-3.93c7.19,0,9.28,7.24,9.28,13.06,0,8.05-1.43,16.82-9.08,16.82-2.86,0-4.49-1.42-6-3.72ZM117.3,28.3c-5.26,0-5.36,7.44-5.36,11.47s-.15,11.58,5.41,11.58c4.18,0,5.51-4.39,5.51-12C122.86,35.59,122.45,28.3,117.3,28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143,54.76c-6.12,0-10.15-3.67-10.15-15.91,0-8.56,3.16-14,10.15-14s10.15,5.41,10.15,14C153.1,51.14,149.17,54.76,143,54.76Zm0-26.46c-4.13,0-6,3.26-6,11.83,0,6.68,1.28,11.22,6,11.22s6-4.54,6-11.22C148.92,31.56,147.18,28.3,143,28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.17,30.29h.1c1.68-3.73,4.08-5.31,8.31-4.95v4c-5.2-.92-8.26,2.34-8.26,7.49V54h-4V25.65h3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.3,25.65H187v3.41h-4.69V48.39c0,1-.36,2.19,1.88,2.19h2.71V54H182.5c-2.4,0-4.18-.36-4.18-4.64V29.06h-3.93V25.65h3.93V18h4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 189,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.66,35h-13v3.9h8.69c.05,6.19-.68,13.52-8.69,13.16-7.69-.37-7.38-10.72-7.38-16.64,0-6.66.1-16.44,8.63-16.28,4.94.1,7,3.43,7,8.22h4.37c.1-7.28-4.16-12.12-11.6-12.12-11.28,0-12.89,10.92-12.89,20s.88,20.7,12.48,20.7c4.31,0,7.8-2.29,8.94-6.71h.11v6.08h3.32ZM225.45,55V51.1H210.16V36.7h14.25V32.8H210.16V19.9h15.19V16h-19.5V55ZM197,10h67V60H197Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3 80)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5"
  }, "Easi"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.22,
    y: 0
  }, "n")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(48.42 80)"
  }, "g"), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(69 80)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 8.69,
    y: 0
  }, "ranspo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 65.97,
    y: 0
  }, "r")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(141.62 80)"
  }, "t"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(157 80)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8"
  }, "Managemen"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.04,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3,
    y: 65,
    width: 261,
    height: 19
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(269 20)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 0
  }, "M"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransLogo);
export default __webpack_public_path__ + "static/media/trans-logo.c6d75f2c567b2f453e0e8f3ead5a1f07.svg";
export { ForwardRef as ReactComponent };